<template>
  <div>
    <el-tooltip :content="tooltipContent" placement="top">
      <a
        href
        :class="[btnType, btnStyle]"
        @click.prevent="classifyInvestor(investor)"
      >
        <i v-if="isIcon" class="ion ion-ios-chatboxes" />
        {{ buttonText }}
      </a>
    </el-tooltip>
  </div>
</template>

<script>
import notifications from '@/services/notifications'

export default {
  props: ['investor', 'isIcon'],
  computed: {
    btnStyle() {
      return {
        'btn-success': this.investor.state === null,
        'btn-danger': this.investor.state === 'applied',
        'btn-warning': this.investor.state === 'cancelled',
      }
    },
    btnType() {
      return {
        'btn btn-xs': this.isIcon,
        'btn btn-sm btn-transparent': this.isIcon === false,
      }
    },
    buttonText() {
      const investorStatus = this.investor.state

      if (!this.isIcon) {
        return investorStatus === 'applied' ? 'Cancel' : 'Apply'
      }
      return null
    },
    tooltipContent() {
      return this.investor.state === 'applied'
        ? 'Cancel application'
        : 'Apply for investment'
    },
  },
  methods: {
    async classifyInvestor(investor, status = 'applied') {
      if (investor.state === 'applied') status = 'cancelled'

      try {
        await this.$store.dispatch('investorList/classifyInvestor', {
          investor,
          status,
        })

        if (status === 'cancelled') {
          return notifications.notify({
            title: 'Investment application cancelled!',
            type: 'warning',
          })
        }

        return notifications.notify({
          title: 'Applied for investment!',
          type: 'success',
        })
      } catch (error) {
        notifications.notify({ title: 'Something went wrong', type: 'danger' })
      }
    },
  },
}
</script>
